import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import TimePicker from "./TimePicker";

const TimePickerPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox title={"Time Picker"} description={""} />
      <Divider light />
      <TimePicker />
    </Paper>
  );
};

export default TimePickerPage;
